// Comprehensive mapping of Magic: The Gathering set names to their official set codes
// This mapping is critical for trade initiation to work correctly with the backend API

export const SET_MAPPINGS: Record<string, string> = {
  '15th Anniversary Cards': 'p15a',
  '2016 Heroes of the Realm': 'phtr',
  '2017 Gift Pack': 'g17',
  '2017 Heroes of the Realm': 'ph17',
  '2018 Heroes of the Realm': 'ph18',
  '2019 Heroes of the Realm': 'ph19',
  '2020 Heroes of the Realm': 'ph20',
  '2021 Heroes of the Realm': 'ph21',
  '2022 Heroes of the Realm': 'ph22',
  '2023 Heroes of the Realm': 'ph23',
  '30th Anniversary Celebration Tokyo': 'p30t',
  '30th Anniversary Edition': '30a',
  '30th Anniversary History Promos': 'p30h',
  '30th Anniversary Misc Promos': 'p30m',
  '30th Anniversary Play Promos': 'p30a',
  '30th Anniversary Tokens': 't30a',
  'Adventures in the Forgotten Realms': 'afr',
  'Adventures in the Forgotten Realms Art Series': 'aafr',
  'Adventures in the Forgotten Realms Minigames': 'mafr',
  'Adventures in the Forgotten Realms Promos': 'pafr',
  'Adventures in the Forgotten Realms Tokens': 'tafr',
  'Aether Revolt': 'aer',
  'Aether Revolt Promos': 'paer',
  'Aether Revolt Tokens': 'taer',
  'Aetherdrift': 'dft',
  'Aetherdrift Art Series': 'adft',
  'Aetherdrift Commander': 'drc',
  'Aetherdrift Commander Tokens': 'tdrc',
  'Aetherdrift Promos': 'pdft',
  'Aetherdrift Tokens': 'tdft',
  'Alara Reborn': 'arb',
  'Alara Reborn Promos': 'parb',
  'Alara Reborn Tokens': 'tarb',
  'Alchemy Horizons: Baldur\'s Gate': 'hbg',
  'Alchemy: Aetherdrift': 'ydft',
  'Alchemy: Bloomburrow': 'yblb',
  'Alchemy: Dominaria': 'ydmu',
  'Alchemy: Duskmourn': 'ydsk',
  'Alchemy: Edge of Eternities': 'yeoe',
  'Alchemy: Innistrad': 'ymid',
  'Alchemy: Ixalan': 'ylci',
  'Alchemy: Kamigawa': 'yneo',
  'Alchemy: Murders at Karlov Manor': 'ymkm',
  'Alchemy: New Capenna': 'ysnc',
  'Alchemy: Outlaws of Thunder Junction': 'yotj',
  'Alchemy: Phyrexia': 'yone',
  'Alchemy: Tarkir': 'ytdm',
  'Alchemy: The Brothers\' War': 'ybro',
  'Alchemy: Wilds of Eldraine': 'ywoe',
  'Alliances': 'all',
  'Amonkhet': 'akh',
  'Amonkhet Invocations': 'mp2',
  'Amonkhet Promos': 'pakh',
  'Amonkhet Remastered': 'akr',
  'Amonkhet Tokens': 'takh',
  'Anthologies': 'ath',
  'Antiquities': 'atq',
  'Apocalypse': 'apc',
  'Apocalypse Promos': 'papc',
  'Arabian Nights': 'arn',
  'Archenemy': 'arc',
  'Archenemy Schemes': 'oarc',
  'Archenemy: Nicol Bolas': 'e01',
  'Archenemy: Nicol Bolas Schemes': 'oe01',
  'Archenemy: Nicol Bolas Tokens': 'te01',
  'Arena Anthology 1': 'aa1',
  'Arena Anthology 2': 'aa2',
  'Arena Beginner Set': 'anb',
  'Arena League 1996': 'parl',
  'Arena League 1999': 'pal99',
  'Arena League 2000': 'pal00',
  'Arena League 2001': 'pal01',
  'Arena League 2002': 'pal02',
  'Arena League 2003': 'pal03',
  'Arena League 2004': 'pal04',
  'Arena League 2005': 'pal05',
  'Arena League 2006': 'pal06',
  'Arena New Player Experience': 'ana',
  'Arena New Player Experience Cards': 'oana',
  'Arena New Player Experience Extras': 'xana',
  'Asia Pacific Land Program': 'palp',
  'Assassin\'s Creed': 'acr',
  'Assassin\'s Creed Art Series': 'aacr',
  'Assassin\'s Creed Minigames': 'macr',
  'Assassin\'s Creed Tokens': 'tacr',
  'Astral Cards': 'past',
  'Avacyn Restored': 'avr',
  'Avacyn Restored Promos': 'pavr',
  'Avacyn Restored Tokens': 'tavr',
  'Avatar: The Last Airbender': 'tla',
  'Avatar: The Last Airbender Eternal': 'tle',
  'Avatar: The Last Airbender Front Cards': 'ftla',
  'Battle for Baldur\'s Gate Art Series': 'aclb',
  'Battle for Baldur\'s Gate Oversized Cards': 'oclb',
  'Battle for Baldur\'s Gate Promos': 'pclb',
  'Battle for Baldur\'s Gate Tokens': 'tclb',
  'Battle for Zendikar': 'bfz',
  'Battle for Zendikar Promos': 'pbfz',
  'Battle for Zendikar Tokens': 'tbfz',
  'Battle Royale Box Set': 'brb',
  'Battle the Horde': 'tbth',
  'Battlebond': 'bbd',
  'Battlebond Promos': 'pbbd',
  'Battlebond Tokens': 'tbbd',
  'Beatdown Box Set': 'btd',
  'Betrayers of Kamigawa': 'bok',
  'Betrayers of Kamigawa Promos': 'pbok',
  'BFZ Standard Series': 'pss1',
  'Bloomburrow': 'blb',
  'Bloomburrow Art Series': 'ablb',
  'Bloomburrow Commander': 'blc',
  'Bloomburrow Commander Tokens': 'tblc',
  'Bloomburrow Promos': 'pblb',
  'Bloomburrow Tokens': 'tblb',
  'Born of the Gods': 'bng',
  'Born of the Gods Hero\'s Path': 'thp2',
  'Born of the Gods Promos': 'pbng',
  'Born of the Gods Tokens': 'tbng',
  'Breaking News': 'otp',
  'Breaking News Tokens': 'totp',
  'Celebration Cards': 'pcel',
  'Challenger Decks 2022': 'q07',
  'Champions of Kamigawa': 'chk',
  'Champions of Kamigawa Promos': 'pchk',
  'Champs and States': 'pcmp',
  'Chronicles': 'chr',
  'Chronicles Foreign Black Border': 'bchr',
  'Classic Sixth Edition': '6ed',
  'Sixth Edition': '6ed',
  '6th Edition': '6ed',
  'Coldsnap': 'csp',
  'Coldsnap Promos': 'pcsp',
  'Coldsnap Theme Decks': 'cst',
  'Collectors\' Edition': 'ced',
  'Commander\'s Arsenal': 'cm1',
  'Commander\'s Arsenal Oversized': 'ocm1',
  'Commander 2011': 'cmd',
  'Commander 2011 Launch Party': 'pcmd',
  'Commander 2011 Oversized': 'ocmd',
  'Commander 2013': 'c13',
  'Commander 2013 Oversized': 'oc13',
  'Commander 2014': 'c14',
  'Commander 2014 Oversized': 'oc14',
  'Commander 2014 Tokens': 'tc14',
  'Commander 2015': 'c15',
  'Commander 2015 Oversized': 'oc15',
  'Commander 2015 Tokens': 'tc15',
  'Commander 2016': 'c16',
  'Commander 2016 Oversized': 'oc16',
  'Commander 2016 Tokens': 'tc16',
  'Commander 2017': 'c17',
  'Commander 2017 Oversized': 'oc17',
  'Commander 2017 Tokens': 'tc17',
  'Commander 2018': 'c18',
  'Commander 2018 Oversized': 'oc18',
  'Commander 2018 Tokens': 'tc18',
  'Commander 2019': 'c19',
  'Commander 2019 Oversized': 'oc19',
  'Commander 2019 Tokens': 'tc19',
  'Commander 2020': 'c20',
  'Commander 2020 Oversized': 'oc20',
  'Commander 2020 Tokens': 'tc20',
  'Commander 2021': 'c21',
  'Commander 2021 Display Commanders': 'oc21',
  'Commander 2021 Tokens': 'tc21',
  'Commander Anthology': 'cma',
  'Commander Anthology Tokens': 'tcma',
  'Commander Anthology Volume II': 'cm2',
  'Commander Anthology Volume II Tokens': 'tcm2',
  'Commander Collection: Black': 'cc2',
  'Commander Collection: Green': 'cc1',
  'Commander Legends': 'cmr',
  'Commander Legends Promos': 'pcmr',
  'Commander Legends Tokens': 'tcmr',
  'Commander Legends: Battle for Baldur\'s Gate': 'clb',
  'Commander Legends: Battle for Baldur\'s Gate Minigames': 'mclb',
  'Commander Masters': 'cmm',
  'Commander Masters Art Series': 'acmm',
  'Commander Masters Tokens': 'tcmm',
  'Conflux': 'con',
  'Conflux Promos': 'pcon',
  'Conflux Tokens': 'tcon',
  'Conspiracy': 'cns',
  'Conspiracy Promos': 'pcns',
  'Conspiracy Tokens': 'tcns',
  'Conspiracy: Take the Crown': 'cn2',
  'Conspiracy: Take the Crown Tokens': 'tcn2',
  'Core Set 2019': 'm19',
  'Core Set 2019 Promos': 'pm19',
  'Core Set 2019 Tokens': 'tm19',
  'Core Set 2020': 'm20',
  'Core Set 2020 Promos': 'pm20',
  'Core Set 2020 Tokens': 'tm20',
  'Core Set 2021': 'm21',
  'Core Set 2021 Promos': 'pm21',
  'Core Set 2021 Tokens': 'tm21',
  'Cowboy Bebop': 'pcbb',
  'Crimson Vow Art Series': 'avow',
  'Crimson Vow Commander': 'voc',
  'Crimson Vow Commander Display Commanders': 'ovoc',
  'Crimson Vow Commander Tokens': 'tvoc',
  'Dark Ascension': 'dka',
  'Dark Ascension Promos': 'pdka',
  'Dark Ascension Tokens': 'tdka',
  'Darksteel': 'dst',
  'Darksteel Promos': 'pdst',
  'DCI Legend Membership': 'plgm',
  'DCI Promos': 'dci',
  'Deckmasters': 'dkm',
  'Defeat a God': 'tdag',
  'Dissension': 'dis',
  'Dissension Promos': 'pdis',
  'DMU Japanese Promo Tokens': 'wdmu',
  'Doctor Who': 'who',
  'Doctor Who Tokens': 'twho',
  'Dominaria': 'dom',
  'Dominaria Promos': 'pdom',
  'Dominaria Remastered': 'dmr',
  'Dominaria Remastered Tokens': 'tdmr',
  'Dominaria Tokens': 'tdom',
  'Dominaria United': 'dmu',
  'Dominaria United Art Series': 'admu',
  'Dominaria United Commander': 'dmc',
  'Dominaria United Commander Tokens': 'tdmc',
  'Dominaria United Jumpstart Front Cards': 'fdmu',
  'Dominaria United Minigames': 'mdmu',
  'Dominaria United Promos': 'pdmu',
  'Dominaria United Southeast Asia Tokens': 'ptdmu',
  'Dominaria United Tokens': 'tdmu',
  'Double Masters': '2xm',
  'Double Masters 2022': '2x2',
  'Double Masters 2022 Tokens': 't2x2',
  'Double Masters Tokens': 't2xm',
  'Dragon\'s Maze': 'dgm',
  'Dragon\'s Maze Promos': 'pdgm',
  'Dragon\'s Maze Tokens': 'tdgm',
  'Dragon Con': 'pdrc',
  'Dragons of Tarkir': 'dtk',
  'Dragons of Tarkir Promos': 'pdtk',
  'Dragons of Tarkir Tokens': 'tdtk',
  'Duel Decks Anthology: Divine vs. Demonic': 'dvd',
  'Duel Decks Anthology: Divine vs. Demonic Tokens': 'tdvd',
  'Duel Decks Anthology: Elves vs. Goblins': 'evg',
  'Duel Decks Anthology: Elves vs. Goblins Tokens': 'tevg',
  'Duel Decks Anthology: Garruk vs. Liliana': 'gvl',
  'Duel Decks Anthology: Garruk vs. Liliana Tokens': 'tgvl',
  'Duel Decks Anthology: Jace vs. Chandra': 'jvc',
  'Duel Decks Anthology: Jace vs. Chandra Tokens': 'tjvc',
  'Duel Decks: Ajani vs. Nicol Bolas': 'ddh',
  'Duel Decks: Ajani vs. Nicol Bolas Tokens': 'tddh',
  'Duel Decks: Blessed vs. Cursed': 'ddq',
  'Duel Decks: Divine vs. Demonic': 'ddc',
  'Duel Decks: Divine vs. Demonic Tokens': 'tddc',
  'Duel Decks: Elspeth vs. Kiora': 'ddo',
  'Duel Decks: Elspeth vs. Tezzeret': 'ddf',
  'Duel Decks: Elspeth vs. Tezzeret Tokens': 'tddf',
  'Duel Decks: Elves vs. Goblins': 'dd1',
  'Duel Decks: Elves vs. Goblins Tokens': 'tdd1',
  'Duel Decks: Elves vs. Inventors': 'ddu',
  'Duel Decks: Elves vs. Inventors Tokens': 'tddu',
  'Duel Decks: Garruk vs. Liliana': 'ddd',
  'Duel Decks: Garruk vs. Liliana Tokens': 'tddd',
  'Duel Decks: Heroes vs. Monsters': 'ddl',
  'Duel Decks: Heroes vs. Monsters Tokens': 'tddl',
  'Duel Decks: Izzet vs. Golgari': 'ddj',
  'Duel Decks: Izzet vs. Golgari Tokens': 'tddj',
  'Duel Decks: Jace vs. Chandra': 'dd2',
  'Duel Decks: Jace vs. Chandra Tokens': 'tdd2',
  'Duel Decks: Jace vs. Vraska': 'ddm',
  'Duel Decks: Jace vs. Vraska Tokens': 'tddm',
  'Duel Decks: Knights vs. Dragons': 'ddg',
  'Duel Decks: Knights vs. Dragons Tokens': 'tddg',
  'Duel Decks: Merfolk vs. Goblins': 'ddt',
  'Duel Decks: Merfolk vs. Goblins Tokens': 'tddt',
  'Duel Decks: Mind vs. Might': 'dds',
  'Duel Decks: Mind vs. Might Tokens': 'tdds',
  'Duel Decks: Mirrodin Pure vs. New Phyrexia': 'td2',
  'Duel Decks: Nissa vs. Ob Nixilis': 'ddr',
  'Duel Decks: Phyrexia vs. the Coalition': 'dde',
  'Duel Decks: Phyrexia vs. the Coalition Tokens': 'tdde',
  'Duel Decks: Sorin vs. Tibalt': 'ddk',
  'Duel Decks: Sorin vs. Tibalt Tokens': 'tddk',
  'Duel Decks: Speed vs. Cunning': 'ddn',
  'Duel Decks: Venser vs. Koth': 'ddi',
  'Duel Decks: Venser vs. Koth Tokens': 'tddi',
  'Duel Decks: Zendikar vs. Eldrazi': 'ddp',
  'Duels of the Planeswalkers': 'dpa',
  'Duels of the Planeswalkers 2009 Promos': 'pdtp',
  'Duels of the Planeswalkers 2010 Promos': 'pdp10',
  'Duels of the Planeswalkers 2012 Promos': 'pdp12',
  'Duels of the Planeswalkers 2013 Promos': 'pdp13',
  'Duels of the Planeswalkers 2014 Promos': 'pdp14',
  'Duels of the Planeswalkers 2015 Promos': 'pdp15',
  'Duskmourn Commander Tokens': 'tdsc',
  'Duskmourn: House of Horror': 'dsk',
  'Duskmourn: House of Horror Art Series': 'adsk',
  'Duskmourn: House of Horror Commander': 'dsc',
  'Duskmourn: House of Horror Promos': 'pdsk',
  'Duskmourn: House of Horror Tokens': 'tdsk',
  'Edge of Eternities': 'eoe',
  'Edge of Eternities Art Series': 'aeoe',
  'Edge of Eternities Commander': 'eoc',
  'Edge of Eternities Commander Tokens': 'teoc',
  'Edge of Eternities Promos': 'peoe',
  'Edge of Eternities Tokens': 'teoe',
  'Edge of Eternities: Stellar Sights': 'eos',
  'Eighth Edition': '8ed',
  'Eighth Edition Promos': 'p8ed',
  'Eldritch Moon': 'emn',
  'Eldritch Moon Promos': 'pemn',
  'Eldritch Moon Tokens': 'temn',
  'Eternal Masters': 'ema',
  'Eternal Masters Tokens': 'tema',
  'Eternal Weekend': 'pewk',
  'European Land Program': 'pelp',
  'Eventide': 'eve',
  'Eventide Promos': 'peve',
  'Eventide Tokens': 'teve',
  'Exodus': 'exo',
  'Exodus Promos': 'pexo',
  'Explorer Anthology 1': 'ea1',
  'Explorer Anthology 2': 'ea2',
  'Explorer Anthology 3': 'ea3',
  'Explorers of Ixalan': 'e02',
  'Face the Hydra': 'tfth',
  'Fallen Empires': 'fem',
  'Fallout': 'pip',
  'Fallout Tokens': 'tpip',
  'Fate Reforged': 'frf',
  'Fate Reforged Clash Pack': 'cp2',
  'Fate Reforged Promos': 'pfrf',
  'Fate Reforged Tokens': 'tfrf',
  'Fifth Dawn': '5dn',
  'Fifth Dawn Promos': 'p5dn',
  'Fifth Edition': '5ed',
  'FIN Standard Showdown': 'pss5',
  'Final Fantasy': 'fin',
  'Final Fantasy Art Series': 'afin',
  'Final Fantasy Commander': 'fic',
  'Final Fantasy Commander Tokens': 'tfic',
  'Final Fantasy Promos': 'pfin',
  'Final Fantasy Regional Promos': 'rfin',
  'Final Fantasy Tokens': 'tfin',
  'Final Fantasy: Through the Ages': 'fca',
  'Foreign Black Border': 'fbb',
  'Forgotten Realms Commander': 'afc',
  'Forgotten Realms Commander Display Commanders': 'oafc',
  'Forgotten Realms Commander Tokens': 'tafc',
  'Forgotten Realms Oversized Cards': 'oafr',
  'Foundations': 'fdn',
  'Foundations Art Series': 'afdn',
  'Foundations Commander': 'fdc',
  'Foundations Front Cards': 'ffdn',
  'Foundations Jumpstart': 'j25',
  'Foundations Jumpstart Front Cards': 'fj25',
  'Foundations Promos': 'pfdn',
  'Foundations Tokens': 'tfdn',
  'Fourth Edition': '4ed',
  'Fourth Edition Foreign Black Border': '4bb',
  'Friday Night Magic 2000': 'fnm',
  'Friday Night Magic 2001': 'f01',
  'Friday Night Magic 2002': 'f02',
  'Friday Night Magic 2003': 'f03',
  'Friday Night Magic 2004': 'f04',
  'Friday Night Magic 2005': 'f05',
  'Friday Night Magic 2006': 'f06',
  'Friday Night Magic 2007': 'f07',
  'Friday Night Magic 2008': 'f08',
  'Friday Night Magic 2009': 'f09',
  'Friday Night Magic 2010': 'f10',
  'Friday Night Magic 2011': 'f11',
  'Friday Night Magic 2012': 'f12',
  'Friday Night Magic 2013': 'f13',
  'Friday Night Magic 2014': 'f14',
  'Friday Night Magic 2015': 'f15',
  'Friday Night Magic 2016': 'f16',
  'Friday Night Magic 2017': 'f17',
  'Friday Night Magic 2018': 'f18',
  'From the Vault: Angels': 'v15',
  'From the Vault: Annihilation': 'v14',
  'From the Vault: Dragons': 'drb',
  'From the Vault: Exiled': 'v09',
  'From the Vault: Legends': 'v11',
  'From the Vault: Lore': 'v16',
  'From the Vault: Realms': 'v12',
  'From the Vault: Relics': 'v10',
  'From the Vault: Transform': 'v17',
  'From the Vault: Twenty': 'v13',
  'Future Sight': 'fut',
  'Future Sight Promos': 'pfut',
  'Game Day Promos': 'gdy',
  'Game Night': 'gnt',
  'Game Night 2019': 'gn2',
  'Game Night 2019 Tokens': 'tgn2',
  'Game Night: Free-for-All': 'gn3',
  'Game Night: Free-for-All Tokens': 'tgn3',
  'Gatecrash': 'gtc',
  'Gatecrash Promos': 'pgtc',
  'Gatecrash Tokens': 'tgtc',
  'Global Series Jiang Yanggu & Mu Yanling': 'gs1',
  'Grand Prix Promos': 'pgpx',
  'GRN Guild Kit': 'gk1',
  'GRN Guild Kit Tokens': 'tgk1',
  'GRN Ravnica Weekend': 'prwk',
  'Guildpact': 'gpt',
  'Guildpact Promos': 'pgpt',
  'Guilds of Ravnica': 'grn',
  'Guilds of Ravnica Promos': 'pgrn',
  'Guilds of Ravnica Tokens': 'tgrn',
  'Guru': 'pgru',
  'Hachette UK': 'phuk',
  'Happy Holidays': 'hho',
  'HarperPrism Book Promos': 'phpr',
  'HasCon 2017': 'h17',
  'Historic Anthology 1': 'ha1',
  'Historic Anthology 2': 'ha2',
  'Historic Anthology 3': 'ha3',
  'Historic Anthology 4': 'ha4',
  'Historic Anthology 5': 'ha5',
  'Historic Anthology 6': 'ha6',
  'Historic Anthology 7': 'ha7',
  'Hobby Japan Promos': 'jp1',
  'Homelands': 'hml',
  'Hour of Devastation': 'hou',
  'Hour of Devastation Promos': 'phou',
  'Hour of Devastation Tokens': 'thou',
  'Ice Age': 'ice',
  'Iconic Masters': 'ima',
  'Iconic Masters Tokens': 'tima',
  'IDW Comics Inserts': 'pidw',
  'Ikoria: Lair of Behemoths': 'iko',
  'Ikoria: Lair of Behemoths Promos': 'piko',
  'Ikoria: Lair of Behemoths Tokens': 'tiko',
  'Innistrad': 'isd',
  'Innistrad Promos': 'pisd',
  'Innistrad Remastered': 'inr',
  'Innistrad Remastered Art Series': 'ainr',
  'Innistrad Remastered Tokens': 'tinr',
  'Innistrad Tokens': 'tisd',
  'Innistrad: Crimson Vow': 'vow',
  'Innistrad: Crimson Vow Minigames': 'mvow',
  'Innistrad: Crimson Vow Promos': 'pvow',
  'Innistrad: Crimson Vow Substitute Cards': 'svow',
  'Innistrad: Crimson Vow Tokens': 'tvow',
  'Innistrad: Double Feature': 'dbl',
  'Innistrad: Midnight Hunt': 'mid',
  'Innistrad: Midnight Hunt Minigames': 'mmid',
  'Innistrad: Midnight Hunt Promos': 'pmid',
  'Innistrad: Midnight Hunt Substitute Cards': 'smid',
  'Innistrad: Midnight Hunt Tokens': 'tmid',
  'Intl. Collectors\' Edition': 'cei',
  'Introductory Two-Player Set': 'itp',
  'Invasion': 'inv',
  'Invasion Promos': 'pinv',
  'Ixalan': 'xln',
  'Ixalan Promos': 'pxln',
  'Ixalan Tokens': 'txln',
  'Japan Junior Tournament': 'pjjt',
  'Japan Standard Cup': 'pjsc',
  'Journey into Nyx': 'jou',
  'Journey into Nyx Hero\'s Path': 'thp3',
  'Journey into Nyx Promos': 'pjou',
  'Journey into Nyx Tokens': 'tjou',
  'Judge Gift Cards 1998': 'jgp',
  'Judge Gift Cards 1999': 'g99',
  'Judge Gift Cards 2000': 'g00',
  'Judge Gift Cards 2001': 'g01',
  'Judge Gift Cards 2002': 'g02',
  'Judge Gift Cards 2003': 'g03',
  'Judge Gift Cards 2004': 'g04',
  'Judge Gift Cards 2005': 'g05',
  'Judge Gift Cards 2006': 'g06',
  'Judge Gift Cards 2007': 'g07',
  'Judge Gift Cards 2008': 'g08',
  'Judge Gift Cards 2009': 'g09',
  'Judge Gift Cards 2010': 'g10',
  'Judge Gift Cards 2011': 'g11',
  'Judge Gift Cards 2012': 'j12',
  'Judge Gift Cards 2013': 'j13',
  'Judge Gift Cards 2014': 'j14',
  'Judge Gift Cards 2015': 'j15',
  'Judge Gift Cards 2016': 'j16',
  'Judge Gift Cards 2017': 'j17',
  'Judge Gift Cards 2018': 'j18',
  'Judge Gift Cards 2019': 'j19',
  'Judge Gift Cards 2020': 'j20',
  'Judge Gift Cards 2021': 'pj21',
  'Judge Gift Cards 2022': 'p22',
  'Judge Gift Cards 2023': 'p23',
  'Judgment': 'jud',
  'Judgment Promos': 'pjud',
  'Jumpstart': 'jmp',
  'Jumpstart 2022': 'j22',
  'Jumpstart 2022 Front Cards': 'fj22',
  'Jumpstart Arena Exclusives': 'ajmp',
  'Jumpstart Front Cards': 'fjmp',
  'Jumpstart: Historic Horizons': 'j21',
  'Junior APAC Series': 'pjas',
  'Junior Series Europe': 'pjse',
  'Junior Super Series': 'psus',
  'Jurassic World Collection': 'rex',
  'Jurassic World Collection Tokens': 'trex',
  'Kaladesh': 'kld',
  'Kaladesh Inventions': 'mps',
  'Kaladesh Promos': 'pkld',
  'Kaladesh Remastered': 'klr',
  'Kaladesh Tokens': 'tkld',
  'Kaldheim': 'khm',
  'Kaldheim Art Series': 'akhm',
  'Kaldheim Commander': 'khc',
  'Kaldheim Commander Tokens': 'tkhc',
  'Kaldheim Minigames': 'mkhm',
  'Kaldheim Promos': 'pkhm',
  'Kaldheim Substitute Cards': 'skhm',
  'Kaldheim Tokens': 'tkhm',
  'Kamigawa: Neon Dynasty': 'neo',
  'Kamigawa: Neon Dynasty Minigames': 'mneo',
  'Kamigawa: Neon Dynasty Promos': 'pneo',
  'Kamigawa: Neon Dynasty Substitute Cards': 'sneo',
  'Kamigawa: Neon Dynasty Tokens': 'tneo',
  'Khans of Tarkir': 'ktk',
  'Khans of Tarkir Promos': 'pktk',
  'Khans of Tarkir Tokens': 'tktk',
  'League Tokens 2012': 'l12',
  'League Tokens 2013': 'l13',
  'League Tokens 2014': 'l14',
  'League Tokens 2015': 'l15',
  'League Tokens 2016': 'l16',
  'League Tokens 2017': 'l17',
  'Legacy Championship': 'olgc',
  'Legendary Cube Prize Pack': 'pz1',
  'Legends': 'leg',
  'Legions': 'lgn',
  'Legions Promos': 'plgn',
  'Limited Edition Alpha': 'lea',
  'Limited Edition Beta': 'leb',
  'Lorwyn': 'lrw',
  'Lorwyn Promos': 'plrw',
  'Lorwyn Tokens': 'tlrw',
  'Love Your LGS 2020': 'plg20',
  'Love Your LGS 2021': 'plg21',
  'Love Your LGS 2022': 'plg22',
  'Love Your LGS 2024': 'plg24',
  'Love Your LGS 2025': 'plg25',
  'Lunar New Year 2018': 'plny',
  'M15 Prerelease Challenge': 'ppc1',
  'M19 Gift Pack': 'g18',
  'M19 Standard Showdown': 'pss3',
  'M20 Promo Packs': 'ppp1',
  'Magic × Duel Masters Promos': 'pmda',
  'Magic 2010': 'm10',
  'Magic 2010 Promos': 'pm10',
  'Magic 2010 Tokens': 'tm10',
  'Magic 2011': 'm11',
  'Magic 2011 Promos': 'pm11',
  'Magic 2011 Tokens': 'tm11',
  'Magic 2012': 'm12',
  'Magic 2012 Promos': 'pm12',
  'Magic 2012 Tokens': 'tm12',
  'Magic 2013': 'm13',
  'Magic 2013 Promos': 'pm13',
  'Magic 2013 Tokens': 'tm13',
  'Magic 2014': 'm14',
  'Magic 2014 Promos': 'pm14',
  'Magic 2014 Tokens': 'tm14',
  'Magic 2015': 'm15',
  'Magic 2015 Clash Pack': 'cp1',
  'Magic 2015 Promos': 'pm15',
  'Magic 2015 Tokens': 'tm15',
  'Magic Online Avatars': 'pmoa',
  'Magic Online Promos': 'prm',
  'Magic Online Theme Decks': 'td0',
  'Magic Origins': 'ori',
  'Magic Origins Clash Pack': 'cp3',
  'Magic Origins Promos': 'pori',
  'Magic Origins Tokens': 'tori',
  'Magic Player Rewards 2001': 'mpr',
  'Magic Player Rewards 2002': 'pr2',
  'Magic Player Rewards 2003': 'p03',
  'Magic Player Rewards 2004': 'p04',
  'Magic Player Rewards 2005': 'p05',
  'Magic Player Rewards 2006': 'p06',
  'Magic Player Rewards 2007': 'p07',
  'Magic Player Rewards 2008': 'p08',
  'Magic Player Rewards 2009': 'p09',
  'Magic Player Rewards 2010': 'p10',
  'Magic Player Rewards 2011': 'p11',
  'Magic Premiere Shop 2005': 'pmps',
  'Magic Premiere Shop 2006': 'pmps06',
  'Magic Premiere Shop 2007': 'pmps07',
  'Magic Premiere Shop 2008': 'pmps08',
  'Magic Premiere Shop 2009': 'pmps09',
  'Magic Premiere Shop 2010': 'pmps10',
  'Magic Premiere Shop 2011': 'pmps11',
  'MagicFest 2019': 'pf19',
  'MagicFest 2020': 'pf20',
  'MagicFest 2023': 'pf23',
  'MagicFest 2024': 'pf24',
  'MagicFest 2025': 'pf25',
  'March of the Machine': 'mom',
  'March of the Machine Art Series': 'amom',
  'March of the Machine Commander': 'moc',
  'March of the Machine Commander Tokens': 'tmoc',
  'March of the Machine Jumpstart Front Cards': 'fmom',
  'March of the Machine Promos': 'pmom',
  'March of the Machine Substitute Cards': 'smom',
  'March of the Machine Tokens': 'tmom',
  'March of the Machine: The Aftermath': 'mat',
  'March of the Machine: The Aftermath Promos': 'pmat',
  'Marvel\'s Spider-Man': 'spm',
  'Marvel\'s Spider-Man Eternal': 'spe',
  'Marvel\'s Spider-Man Promos': 'pspm',
  'Marvel\'s Spider-Man Tokens': 'tspm',
  'Marvel Universe': 'mar',
  'Masters 25': 'a25',
  'Masters 25 Tokens': 'ta25',
  'Masters Edition': 'me1',
  'Masters Edition II': 'me2',
  'Masters Edition III': 'me3',
  'Masters Edition IV': 'me4',
  'Media and Collaboration Promos': 'pmei',
  'Mercadian Masques': 'mmq',
  'Mercadian Masques Promos': 'pmmq',
  'MicroProse Promos': 'pmic',
  'Midnight Hunt Art Series': 'amid',
  'Midnight Hunt Commander': 'mic',
  'Midnight Hunt Commander Display Commanders': 'omic',
  'Midnight Hunt Commander Tokens': 'tmic',
  'Mirage': 'mir',
  'Mirrodin': 'mrd',
  'Mirrodin Besieged': 'mbs',
  'Mirrodin Besieged Promos': 'pmbs',
  'Mirrodin Besieged Tokens': 'tmbs',
  'Mirrodin Promos': 'pmrd',
  'MKM Japanese Promo Tokens': 'wmkm',
  'MKM Standard Showdown': 'pss4',
  'Modern Event Deck 2014': 'md1',
  'Modern Event Deck 2014 Tokens': 'tmd1',
  'Modern Horizons': 'mh1',
  'Modern Horizons 1 Timeshifts': 'h1r',
  'Modern Horizons 2': 'mh2',
  'Modern Horizons 2 Art Series': 'amh2',
  'Modern Horizons 2 Minigames': 'mmh2',
  'Modern Horizons 2 Promos': 'pmh2',
  'Modern Horizons 2 Timeshifts': 'h2r',
  'Modern Horizons 2 Tokens': 'tmh2',
  'Modern Horizons 3': 'mh3',
  'Modern Horizons 3 Art Series': 'amh3',
  'Modern Horizons 3 Commander': 'm3c',
  'Modern Horizons 3 Commander Tokens': 'tm3c',
  'Modern Horizons 3 Promos': 'pmh3',
  'Modern Horizons 3 Substitute Cards': 'smh3',
  'Modern Horizons 3 Tokens': 'tmh3',
  'Modern Horizons Art Series': 'amh1',
  'Modern Horizons Promos': 'pmh1',
  'Modern Horizons Tokens': 'tmh1',
  'Modern Masters': 'mma',
  'Modern Masters 2015': 'mm2',
  'Modern Masters 2015 Tokens': 'tmm2',
  'Modern Masters 2017': 'mm3',
  'Modern Masters 2017 Tokens': 'tmm3',
  'Modern Masters Tokens': 'tmma',
  'MOM Japanese Promo Tokens': 'wmom',
  'Morningtide': 'mor',
  'Morningtide Promos': 'pmor',
  'Morningtide Tokens': 'tmor',
  'MTG Arena Promos': 'pana',
  'Multiverse Gift Box': 'mgb',
  'Multiverse Legends': 'mul',
  'Multiverse Legends Tokens': 'tmul',
  'Murders at Karlov Manor': 'mkm',
  'Murders at Karlov Manor Art Series': 'amkm',
  'Murders at Karlov Manor Commander': 'mkc',
  'Murders at Karlov Manor Commander Tokens': 'tmkc',
  'Murders at Karlov Manor Promos': 'pmkm',
  'Murders at Karlov Manor Tokens': 'tmkm',
  'Mystery Booster 2': 'mb2',
  'Mystery Booster Playtest Cards 2019': 'cmb1',
  'Mystery Booster Playtest Cards 2021': 'cmb2',
  'Mythic Edition': 'med',
  'Mythic Edition Tokens': 'tmed',
  'Nationals Promos': 'pnat',
  'Nemesis': 'nem',
  'Nemesis Promos': 'pnem',
  'Neon Dynasty Art Series': 'aneo',
  'Neon Dynasty Commander': 'nec',
  'Neon Dynasty Commander Tokens': 'tnec',
  'New Capenna Art Series': 'asnc',
  'New Capenna Commander': 'ncc',
  'New Capenna Commander Promos': 'pncc',
  'New Capenna Commander Tokens': 'tncc',
  'New Phyrexia': 'nph',
  'New Phyrexia Promos': 'pnph',
  'New Phyrexia Tokens': 'tnph',
  'Ninth Edition': '9ed',
  'Ninth Edition Promos': 'p9ed',
  'Oath of the Gatewatch': 'ogw',
  'Oath of the Gatewatch Promos': 'pogw',
  'Oath of the Gatewatch Tokens': 'togw',
  'Odyssey': 'ody',
  'Odyssey Promos': 'pody',
  'ONE Japanese Promo Tokens': 'wone',
  'Onslaught': 'ons',
  'Onslaught Promos': 'pons',
  'Open the Helvault': 'phel',
  'Outlaws of Thunder Junction': 'otj',
  'Outlaws of Thunder Junction Art Series': 'aotj',
  'Outlaws of Thunder Junction Commander': 'otc',
  'Outlaws of Thunder Junction Commander Tokens': 'totc',
  'Outlaws of Thunder Junction Promos': 'potj',
  'Outlaws of Thunder Junction Tokens': 'totj',
  'Oversized 90\'s Promos': 'o90p',
  'Oversized League Prizes': 'olep',
  'Phyrexia: All Will Be One': 'one',
  'Phyrexia: All Will Be One Art Series': 'aone',
  'Phyrexia: All Will Be One Commander': 'onc',
  'Phyrexia: All Will Be One Commander Tokens': 'tonc',
  'Phyrexia: All Will Be One Jumpstart Front Cards': 'fone',
  'Phyrexia: All Will Be One Minigames': 'mone',
  'Phyrexia: All Will Be One Promos': 'pone',
  'Phyrexia: All Will Be One Tokens': 'tone',
  'Pioneer Anthology 1': 'pa1',
  'Pioneer Challenger Decks 2021': 'q06',
  'Pioneer Masters': 'pio',
  'Planar Chaos': 'plc',
  'Planar Chaos Promos': 'pplc',
  'Planechase': 'hop',
  'Planechase 2012': 'pc2',
  'Planechase 2012 Planes': 'opc2',
  'Planechase Anthology': 'pca',
  'Planechase Anthology Planes': 'opca',
  'Planechase Anthology Tokens': 'tpca',
  'Planechase Planes': 'ohop',
  'Planechase Promos': 'phop',
  'Planeshift': 'pls',
  'Planeshift Promos': 'ppls',
  'Planeswalker Championship Promos': 'pwcs',
  'Ponies: The Galloping': 'ptg',
  'Portal': 'por',
  'Portal Second Age': 'p02',
  'Portal Three Kingdoms': 'ptk',
  'Portal: Three Kingdoms Promos': 'pptk',
  'Premium Deck Series: Fire and Lightning': 'pd2',
  'Premium Deck Series: Graveborn': 'pd3',
  'Premium Deck Series: Slivers': 'h09',
  'Pro Tour Collector Set': 'ptc',
  'Pro Tour Promos': 'ppro',
  'Prophecy': 'pcy',
  'Prophecy Promos': 'ppcy',
  'Ravnica Allegiance': 'rna',
  'Ravnica Allegiance Promos': 'prna',
  'Ravnica Allegiance Tokens': 'trna',
  'Ravnica Remastered': 'rvr',
  'Ravnica Remastered Tokens': 'trvr',
  'Ravnica: City of Guilds': 'rav',
  'Ravnica: City of Guilds Promos': 'prav',
  'Ravnica: Clue Edition': 'clu',
  'Ravnica: Clue Edition Front Cards': 'fclu',
  'Redemption Program': 'pred',
  'Regional Championship Qualifiers 2022': 'prcq',
  'Regional Championship Qualifiers 2023': 'pr23',
  'Renaissance': 'ren',
  'Return to Ravnica': 'rtr',
  'Return to Ravnica Promos': 'prtr',
  'Return to Ravnica Tokens': 'trtr',
  'Revised Edition': '3ed',
  'Rinascimento': 'rin',
  'Rise of the Eldrazi': 'roe',
  'Rise of the Eldrazi Promos': 'proe',
  'Rise of the Eldrazi Tokens': 'troe',
  'Rivals of Ixalan': 'rix',
  'Rivals of Ixalan Promos': 'prix',
  'Rivals of Ixalan Tokens': 'trix',
  'Rivals Quick Start Set': 'rqs',
  'RNA Guild Kit': 'gk2',
  'RNA Guild Kit Tokens': 'tgk2',
  'RNA Ravnica Weekend': 'prw2',
  'Salvat 2005': 'psal',
  'Salvat 2011': 'ps11',
  'San Diego Comic-Con 2013': 'psdc',
  'San Diego Comic-Con 2014': 'ps14',
  'San Diego Comic-Con 2015': 'ps15',
  'San Diego Comic-Con 2016': 'ps16',
  'San Diego Comic-Con 2017': 'ps17',
  'San Diego Comic-Con 2018': 'ps18',
  'San Diego Comic-Con 2019': 'ps19',
  'Saviors of Kamigawa': 'sok',
  'Saviors of Kamigawa Promos': 'psok',
  'Scars of Mirrodin': 'som',
  'Scars of Mirrodin Promos': 'psom',
  'Scars of Mirrodin Tokens': 'tsom',
  'Scourge': 'scg',
  'Scourge Promos': 'pscg',
  'Secret Lair 30th Anniversary Countdown Kit': 'slc',
  'Secret Lair Drop': 'sld',
  'Secret Lair Showcase Planes': 'pssc',
  'Secret Lair Showdown': 'slp',
  'Secret Lair: Ultimate Edition': 'slu',
  'Sega Dreamcast Cards': 'psdg',
  'Seventh Edition': '7ed',
  'Shadowmoor': 'shm',
  'Shadowmoor Promos': 'pshm',
  'Shadowmoor Tokens': 'tshm',
  'Shadows of the Past': 'sis',
  'Shadows over Innistrad': 'soi',
  'Shadows over Innistrad Promos': 'psoi',
  'Shadows over Innistrad Remastered': 'sir',
  'Shadows over Innistrad Tokens': 'tsoi',
  'Shards of Alara': 'ala',
  'Shards of Alara Promos': 'pala',
  'Shards of Alara Tokens': 'tala',
  'Signature Spellbook: Chandra': 'ss3',
  'Signature Spellbook: Gideon': 'ss2',
  'Signature Spellbook: Jace': 'ss1',
  'Special Guests': 'spg',
  'Spotlight Series': 'pspl',
  'Starter 1999': 's99',
  'Starter 2000': 's00',
  'Starter Commander Deck Tokens': 'tscd',
  'Starter Commander Decks': 'scd',
  'Store Championships': 'sch',
  'Streets of New Capenna': 'snc',
  'Streets of New Capenna Minigames': 'msnc',
  'Streets of New Capenna Promos': 'psnc',
  'Streets of New Capenna Southeast Asia Tokens': 'ptsnc',
  'Streets of New Capenna Tokens': 'tsnc',
  'Strixhaven Art Series': 'astx',
  'Strixhaven Mystical Archive': 'sta',
  'Strixhaven: School of Mages': 'stx',
  'Strixhaven: School of Mages Minigames': 'mstx',
  'Strixhaven: School of Mages Promos': 'pstx',
  'Strixhaven: School of Mages Substitute Cards': 'sstx',
  'Strixhaven: School of Mages Tokens': 'tstx',
  'Stronghold': 'sth',
  'Stronghold Promos': 'psth',
  'Summer Magic / Edgar': 'sum',
  'Summer Vacation Promos 2022': 'psvc',
  'Tales of Middle-earth Art Series': 'altr',
  'Tales of Middle-earth Commander': 'ltc',
  'Tales of Middle-earth Commander Tokens': 'tltc',
  'Tales of Middle-earth Deluxe Commander Kit': 'pltc',
  'Tales of Middle-earth Front Cards': 'fltr',
  'Tales of Middle-earth Promos': 'pltr',
  'Tales of Middle-earth Scene Box': 'altc',
  'Tales of Middle-earth Tokens': 'tltr',
  'Tarkir Dragonfury': 'ptkdf',
  'Tarkir: Dragonstorm': 'tdm',
  'Tarkir: Dragonstorm Art Series': 'atdm',
  'Tarkir: Dragonstorm Commander': 'tdc',
  'Tarkir: Dragonstorm Commander Tokens': 'ttdc',
  'Tarkir: Dragonstorm Promos': 'ptdm',
  'Tarkir: Dragonstorm Tokens': 'ttdm',
  'Tempest': 'tmp',
  'Tempest Promos': 'ptmp',
  'Tempest Remastered': 'tpr',
  'Tenth Edition': '10e',
  'Tenth Edition Promos': 'p10e',
  'Tenth Edition Tokens': 't10e',
  'The Big Score': 'big',
  'The Big Score Promos': 'pbig',
  'The Big Score Tokens': 'tbig',
  'The Brothers\' War': 'bro',
  'The Brothers\' War Art Series': 'abro',
  'The Brothers\' War Commander': 'brc',
  'The Brothers\' War Commander Tokens': 'tbrc',
  'The Brothers\' War Jumpstart Front Cards': 'fbro',
  'The Brothers\' War Minigames': 'mbro',
  'The Brothers\' War Promos': 'pbro',
  'The Brothers\' War Retro Artifacts': 'brr',
  'The Brothers\' War Southeast Asia Tokens': 'ptbro',
  'The Brothers\' War Substitute Cards': 'sbro',
  'The Brothers\' War Tokens': 'tbro',
  'The Dark': 'drk',
  'The List': 'plst',
  'The List (Unfinity Foil Edition)': 'ulst',
  'The Lord of the Rings: Tales of Middle-earth': 'ltr',
  'The Lord of the Rings: Tales of Middle-earth Minigames': 'mltr',
  'The Lost Caverns of Ixalan': 'lci',
  'The Lost Caverns of Ixalan Art Series': 'alci',
  'The Lost Caverns of Ixalan Commander': 'lcc',
  'The Lost Caverns of Ixalan Commander Tokens': 'tlcc',
  'The Lost Caverns of Ixalan Promos': 'plci',
  'The Lost Caverns of Ixalan Substitute Cards': 'slci',
  'The Lost Caverns of Ixalan Tokens': 'tlci',
  'Theros': 'ths',
  'Theros Beyond Death': 'thb',
  'Theros Beyond Death Promos': 'pthb',
  'Theros Beyond Death Tokens': 'tthb',
  'Theros Hero\'s Path': 'thp1',
  'Theros Promos': 'pths',
  'Theros Tokens': 'tths',
  'Throne of Eldraine': 'eld',
  'Throne of Eldraine Promos': 'peld',
  'Throne of Eldraine Tokens': 'teld',
  'Time Spiral': 'tsp',
  'Time Spiral Promos': 'ptsp',
  'Time Spiral Remastered': 'tsr',
  'Time Spiral Remastered Promos': 'ptsr',
  'Time Spiral Remastered Tokens': 'ttsr',
  'Time Spiral Timeshifted': 'tsb',
  'Torment': 'tor',
  'Torment Promos': 'ptor',
  'Transformers': 'bot',
  'Transformers Tokens': 'tbot',
  'Treasure Chest': 'pz2',
  'Two-Headed Giant Tournament': 'p2hg',
  'Ugin\'s Fate': 'ugin',
  'Ultimate Box Topper': 'puma',
  'Ultimate Masters': 'uma',
  'Ultimate Masters Tokens': 'tuma',
  'Unfinity': 'unf',
  'Unfinity Sticker Sheets': 'sunf',
  'Unfinity Tokens': 'tunf',
  'Unglued': 'ugl',
  'Unglued Tokens': 'tugl',
  'Unhinged': 'unh',
  'Unhinged Promos': 'punh',
  'Universes Within': 'slx',
  'Unknown Event': 'unk',
  'Unlimited Edition': '2ed',
  'Unsanctioned': 'und',
  'Unsanctioned Tokens': 'tund',
  'Unstable': 'ust',
  'Unstable Promos': 'pust',
  'Unstable Tokens': 'tust',
  'URL/Convention Promos': 'purl',
  'Urza\'s Destiny': 'uds',
  'Urza\'s Destiny Promos': 'puds',
  'Urza\'s Legacy': 'ulg',
  'Urza\'s Legacy Promos': 'pulg',
  'Urza\'s Saga': 'usg',
  'Urza\'s Saga Promos': 'pusg',
  'Vanguard Series': 'pvan',
  'Vintage Championship': 'ovnt',
  'Vintage Masters': 'vma',
  'Visions': 'vis',
  'War of the Spark': 'war',
  'War of the Spark Promos': 'pwar',
  'War of the Spark Tokens': 'twar',
  'Warhammer 40,000 Commander': '40k',
  'Warhammer 40,000 Tokens': 't40k',
  'Weatherlight': 'wth',
  'Welcome Deck 2016': 'w16',
  'Welcome Deck 2017': 'w17',
  'Wilds of Eldraine': 'woe',
  'Wilds of Eldraine Art Series': 'awoe',
  'Wilds of Eldraine Commander': 'woc',
  'Wilds of Eldraine Commander Tokens': 'twoc',
  'Wilds of Eldraine Promos': 'pwoe',
  'Wilds of Eldraine Tokens': 'twoe',
  'Wilds of Eldraine: Enchanting Tales': 'wot',
  'Wizards of the Coast Online Store': 'pwos',
  'Wizards Play Network 2011': 'pw11',
  'Wizards Play Network 2012': 'pw12',
  'Wizards Play Network 2021': 'pw21',
  'Wizards Play Network 2022': 'pw22',
  'Wizards Play Network 2023': 'pw23',
  'Wizards Play Network 2024': 'pw24',
  'Wizards Play Network 2025': 'pw25',
  'WOE Japanese Promo Tokens': 'wwoe',
  'World Championship Decks 1997': 'wc97',
  'World Championship Decks 1998': 'wc98',
  'World Championship Decks 1999': 'wc99',
  'World Championship Decks 2000': 'wc00',
  'World Championship Decks 2001': 'wc01',
  'World Championship Decks 2002': 'wc02',
  'World Championship Decks 2003': 'wc03',
  'World Championship Decks 2004': 'wc04',
  'World Championship Promos': 'pwor',
  'World Magic Cup Qualifiers': 'wmc',
  'Worldwake': 'wwk',
  'Worldwake Promos': 'pwwk',
  'Worldwake Tokens': 'twwk',
  'XLN Standard Showdown': 'pss2',
  'XLN Treasure Chest': 'pxtc',
  'Year of the Dragon 2024': 'pl24',
  'Year of the Ox 2021': 'pl21',
  'Year of the Rabbit 2023': 'pl23',
  'Year of the Snake 2025': 'pl25',
  'Year of the Tiger 2022': 'pl22',
  'Zendikar': 'zen',
  'Zendikar Expeditions': 'exp',
  'Zendikar Promos': 'pzen',
  'Zendikar Rising': 'znr',
  'Zendikar Rising Art Series': 'aznr',
  'Zendikar Rising Commander': 'znc',
  'Zendikar Rising Commander Tokens': 'tznc',
  'Zendikar Rising Expeditions': 'zne',
  'Zendikar Rising Minigames': 'mznr',
  'Zendikar Rising Promos': 'pznr',
  'Zendikar Rising Substitute Cards': 'sznr',
  'Zendikar Rising Tokens': 'tznr',
  'Zendikar Tokens': 'tzen',
};

// Helper function to get set code from set name
export function getSetCode(setName: string): string {
  return SET_MAPPINGS[setName] || setName;
}

// Helper function to check if a string is a UUID
export function isUUID(str: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(str);
}